import { useThree as I } from "@react-three/fiber";
import { memo as R, useRef as A, useLayoutEffect as O } from "react";
import { Object3D as E, DynamicDrawUsage as T } from "three";
import { DegToRadV3 as U } from "../../geometry-utils/three/index5.js";
import { getObject3D as V } from "../../geometry-utils/three/index10.js";
import { useFunction as $ } from "../../hooks/index2.js";
import { jsx as g } from "react/jsx-runtime";
const s = new E(), F = R(({
  mergedList: o,
  visibility: x,
  renderOrder: j,
  onClick: c,
  onContextMenu: m,
  onDoubleClick: v,
  onPointerUp: f,
  onPointerDown: l,
  onPointerOver: u,
  onPointerOut: p,
  onPointerEnter: y,
  onPointerLeave: d,
  onPointerMove: b,
  onPointerCancel: D
}) => {
  const i = A(null), w = I((t) => t.raycaster), n = $((t, a) => {
    t.timeStamp = Date.now();
    const e = o.view, M = o.layer, r = o.instances[t.instanceId || 0];
    e.setVisibility({
      visibility: x,
      visible: M.visible
    }), e.position.fromArray(r.pos), e.rotation.fromArray(U(r.rot));
    const h = w.intersectObject(e);
    a({
      event: t,
      obj: r,
      intersections: h
    });
  });
  return O(() => {
    if (!!i.current) {
      for (let t = 0; t < o.instances.length; t++) {
        const a = o.instances[t];
        V(a, s), s.updateMatrix(), i.current.setMatrixAt(t, s.matrix);
      }
      i.current.instanceMatrix.needsUpdate = !0;
    }
  }, [o.instances]), /* @__PURE__ */ g("instancedMesh", {
    ref: i,
    name: `${o.layerID}-${o.instances[0].name}`,
    args: [void 0, void 0, o.instances.length],
    material: o.layer.material,
    geometry: o.geo,
    renderOrder: j,
    "instanceMatrix-usage": T,
    onClick: c ? (t) => n(t, c) : void 0,
    onContextMenu: m ? (t) => n(t, m) : void 0,
    onDoubleClick: v ? (t) => n(t, v) : void 0,
    onPointerUp: f ? (t) => n(t, f) : void 0,
    onPointerDown: l ? (t) => n(t, l) : void 0,
    onPointerOver: u ? (t) => n(t, u) : void 0,
    onPointerOut: p ? (t) => n(t, p) : void 0,
    onPointerEnter: y ? (t) => n(t, y) : void 0,
    onPointerLeave: d ? (t) => n(t, d) : void 0,
    onPointerMove: b ? (t) => n(t, b) : void 0,
    onPointerCancel: D ? (t) => n(t, D) : void 0
  });
});
F.displayName = "RgInstances";
export {
  F as RgInstances
};
//# sourceMappingURL=index5.js.map
